const Toolbar = ({
  children
}) => {
  return <div className="flex flex-wrap items-center justify-between gap-5 h-[50px] border-b text-base font-medium">{children}</div>;
};
export { Toolbar };